module.exports = __webpack_public_path__ + "img/tiklanish-1.611c047e.png";